import React from 'react';
import { formatRawHours } from '../helpers';
import { ChainableNumberInput } from './chainable-number-input';
export const HoursInput = /*#__PURE__*/ React.forwardRef(({ value, onChange, onBlur, period, use24Hours, ...rest }, ref)=>{
    const handleBlur = (ev)=>{
        if (value) {
            const validHours = formatRawHours(value, use24Hours);
            const intHours = parseInt(value, 10);
            if (!use24Hours && intHours > 12) {
                onChange(validHours, intHours >= 24 ? 'AM' : 'PM');
            } else {
                onChange(validHours);
            }
        }
        onBlur?.(ev);
    };
    const onCycle = (newValue)=>{
        onChange(newValue, period === 'AM' ? 'PM' : 'AM');
    };
    return /*#__PURE__*/ React.createElement(ChainableNumberInput, {
        ref: ref,
        min: use24Hours ? 0 : 1,
        max: use24Hours ? 23 : 12,
        value: value,
        onChange: onChange,
        onCycle: onCycle,
        onBlur: handleBlur,
        "data-hook": "hours",
        ...rest
    });
});
HoursInput.displayName = 'HoursInput';

//# sourceMappingURL=hours-input.js.map